import { render } from "./TeamDetail.vue?vue&type=template&id=f8d770f0&scoped=true"
import script from "./TeamDetail.vue?vue&type=script&lang=js"
export * from "./TeamDetail.vue?vue&type=script&lang=js"

import "./TeamDetail.vue?vue&type=style&index=0&id=f8d770f0&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d770f0"]])

export default __exports__